/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { IStoreSelectorViewProps } from './dobbies-buybox-store-selector';

const StoreSelectorView: React.FC<IStoreSelectorViewProps> = props => {
    const {
        BodyContainerProps,

        HeaderContainerProps,
        HeaderProps,
        ModuleProps,

        // HeaderText,
        locationsMessage,
        search,
        state,
        spinner,
        locationsList,
        noLocationsMessage,
        isDisplayProduct
    } = props;

    return (
        <Module {...ModuleProps}>
            <Node {...HeaderContainerProps}>{HeaderProps}</Node>
            <Node {...BodyContainerProps}>
                {locationsMessage}
                {search}
                {/* {!props.config?.storeSelectorHeaderText?.includes('Check stock') ? (
                    <div
                        style={{
                            borderBottom: '1px solid #D8D8D8',
                            padding: 8,
                            color: 'red'
                        }}
                    >
                        Please note, Click & Collect is currently available in selected stores
                    </div>
                ) : () */}
                {isDisplayProduct && (
                    <div
                        style={{
                            borderBottom: '1px solid #D8D8D8',
                            padding: 8,
                            color: 'red'
                        }}
                    >
                        Please note, display models are shown in-store available to order for home delivery
                    </div>
                )}
                {state.isSearchInProgress ? spinner : <>{locationsList ? locationsList : noLocationsMessage}</>}
            </Node>

            {/* <Node {...FooterContainerProps}>
                {terms}
            </Node> */}
        </Module>
    );
};

export default StoreSelectorView;
